const BASE_DELAY_MS = 2000;
const MAX_DELAY_MS = 5 * 60 * 1000;
const JITTER_RATIO = 0.2;

/**
 * computeBackoffMs (minimal foreground drainer, coordinator finding #1) —
 * `min(2^attempts * 2s, 5min)` + up to 20% jitter. `random` is injectable
 * for deterministic tests; defaults to `Math.random`. Slice 7's own
 * `backoff.ts` task may formalize/replace this with the full design formula
 * (same shape) once the real SyncEngine lands.
 */
export function computeBackoffMs(attempts: number, random: () => number = Math.random): number {
  const base = Math.min(2 ** attempts * BASE_DELAY_MS, MAX_DELAY_MS);
  const jitter = random() * base * JITTER_RATIO;
  return Math.round(base + jitter);
}
